<template>
  <card>
    <template v-slot:default>
      <div class="properties">
        <property name="סוג מנוי" :value="subscriptionTypeText"/>
        <property name="תאריך חיוב הבא" :value="nextPaymentDateDisplayValue"/>
      </div>
    </template>
    <template v-slot:footer>
      <update-credit-card-button/>
    </template>
  </card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import Property from './Property.vue';
import UpdateCreditCardButton from './components/UpdateCreditCardButton.vue';
import dates from '../../../../../utils/dates';

export default {
  name: 'SubscribedSettings',
  components: {
    UpdateCreditCardButton,
    Property,
    Card: BaseUI.Card,
  },
  async created() {
    this.startContentLoading(this.$options.name);
    await this.fetchNextPaymentDate();
    this.doneContentLoading(this.$options.name);
  },
  computed: {
    ...mapState('subscriptionState', ['nextPaymentDate']),
    ...mapGetters('subscriptionState', ['isYearlySubscription']),
    nextPaymentDateDisplayValue() {
      return this.nextPaymentDate ? dates.longHebrewDateFormat(this.nextPaymentDate) : 'בבדיקה';
    },
    subscriptionTypeText() {
      return this.isYearlySubscription ? 'מנוי שנתי' : 'מנוי חודשי';
    },
  },
  methods: {
    ...mapActions('subscriptionState', ['fetchNextPaymentDate']),
    ...mapActions('contentLoader', ['startContentLoading', 'doneContentLoading']),
  },
};
</script>

<style scoped lang="scss">

  @import "./settings";

  @include properties;

</style>
